// Market demo fake API: every makeRequest call is answered from here while the
// tab is in demo mode (see helpers/http.helper.ts). No backend is ever reached.

import { resolveWith, type DemoRequest, type DemoRoute } from '../core';
import { ensureDemoData } from '../data';
import { authRoutes } from './auth.routes';
import { catalogRoutes } from './catalog.routes';
import { notificationRoutes } from './notification.routes';
import { organizationRoutes } from './organization.routes';
import { preOrderRoutes } from './preOrder.routes';

export const routes: DemoRoute[] = [
  ...authRoutes,
  ...organizationRoutes,
  ...preOrderRoutes,
  ...catalogRoutes,
  ...notificationRoutes,
];

export function resolveDemoRequest(req: DemoRequest): Promise<unknown> {
  ensureDemoData();
  return resolveWith(routes, req);
}
